import React from 'react';
import withIcon from '../utilities/withIcon';

const IconHappyFilled = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm3.738 8.815a.75.75 0 0 0-.988.386 3 3 0 0 1-5.5 0 .75.75 0 1 0-1.374.602 4.5 4.5 0 0 0 8.248 0 .75.75 0 0 0-.386-.988zM4.5 5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
    </g>
  );
};

export default withIcon(IconHappyFilled);
